<template>
 <div :class="windowClass">
        <v-toolbar>
          <v-spacer></v-spacer>
          <span style="width: 180px">
               
            <v-autocomplete 
                            :items="CASHIERS"
                            v-model="cashier"
                           
                            dense
                             hide-details
                               single-line
                            item-text="username"
                            item-value="id"
                            return-object=""
                            label="Select Cashier"
                        />
          </span>
          <span style="width: 180px">
                <v-menu
                            ref="menu"
                          
                            v-model="datemenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="selected_date"
                                label="Select Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                single-line
                                class="mr-2"
                                outlined
                                dense
                                hide-details
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="selected_date" no-title scrollable @input="datemenu = false, summaries=[], getItems()">
                            
                            </v-date-picker>
                        </v-menu>
                      </span>     
        </v-toolbar>
          <div class="ma-4">
            <div class="text-center">CREDIT COLLECTION</div>
            <div class="text-center text-body-2">MARQUEZ PEREZ BROKER</div>
            <div class="text-center text-body-2">{{$moment(selected_date).format('MMM DD, YYYY')}}</div>

             <table class="va-table-border-bot va-table mt-8">

              <tbody>
                <tr>
                  <th class="text-left">DATE</th>
                  <th class="text-left">CUSTOMER NAME</th>
                  <th class="text-left">CASHIER</th>
                  <th class="text-left">REMARKS</th>
                  <th class="text-right">AMOUNT PAID</th>
                  <th class="text-right">SERVICE CHARGE</th>
                  <th class="text-right">TRUCKING</th>
                  <th class="text-right">TOTAL</th>
                </tr>
                <tr v-for="(item,index) in CREDIT_PAYMENTS" :key="index">          
                  <td>{{ selected_date }}</td>
                  <td>{{ item.customer }}</td>
                  <td>{{ item.cashier }}</td>
                  <td>{{ item.remarks }}</td>
                  <td class="text-right">{{ $money(item.paid_amount) }}</td>
                  <td class="text-right">{{ $money(item.service_charge) }}</td>
                  <td class="text-right">{{ $money(item.trucking_fee) }}</td>
                  <td class="text-right">{{ $money(item.amount) }}</td>
                </tr>
              
              </tbody>
                 <tfoot >
                  <tr class="font-weight-bold" >     
                    <td class="text-right pt-4" colspan="7" style="border-top: 1px solid #212121;">COLLECTION:</td>     
                    <td class="text-right  pt-4" style="border-top: 1px solid #212121;">{{ $money(PAID) }}</td>
                  </tr>
                  <tr >     
                    <td class="text-right" colspan="7" >SERVICE CHARGE:</td>     
                    <td class="text-right" >{{ $money(SERVICE) }}</td>
                  </tr>
                  <tr >     
                    <td class="text-right" colspan="7">TRUCKING:</td>     
                    <td class="text-right" >{{ $money(TRUCKING) }}</td>
                  </tr>
                  <tr class="font-weight-bold" >          
                    <td class="text-right" colspan="7" style="border-top: 1px solid #212121;">TOTAL:</td>     
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TOTAL) }}</td>
                  </tr>
                  
              </tfoot>
            </table>
          </div>   
  </div>
  </template>
  
  <script>
  import {
  mapMutations
} from 'vuex'

  export default {

     data: () => ({
        summaries: [],
        users:[],
        charges:[],
        cashier: {},
        formated_summaries:[],
        payment_type: "ALL",
        types:["ALL","CASH", "CREDIT"],
        datemenu: false,
        selected_date: ''
    }),
    created(){
      
      if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.selected_date = this.$moment().format('YYYY-MM-DD')
          this.getItems()
          this.getUsers()
      }
    },
    computed:{
      windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }

      },
      CASHIERS(){
            let items = this.users.reduce((res, item) => {
                if(item.role == 'cashier') {
                  res.push(item)
                }
                return res
            },[{username:'All Cashier', id:0}])
          return items
        },
      CREDIT_PAYMENTS(){
            let items = this.summaries.reduce((res, item) => {
                if(item.remarks == 'Full Payment' || item.remarks == 'Partial Payment') {
                  if(this.cashier.username == "All Cashier") {
                    item.service_charge  = this.getCharge(item.id, 'service_charge')
                    item.trucking_fee  = this.getCharge(item.id, 'trucking_fee')
                    item.paid_amount = this.$IsNum(item.amount) - this.$IsNum(item.service_charge) - this.$IsNum(item.trucking_fee)
                    res.push(item)
                  } else {
                    if(this.cashier.username == item.cashier) {
                      res.push(item)
                    }
                  }
                 
                }
                return res
            },[])
          return items
        },
        TOTAL(){
            return this.CREDIT_PAYMENTS.reduce((res, item) => res += this.$IsNum(item.amount), 0)
        },
        TRUCKING(){
            return this.CREDIT_PAYMENTS.reduce((res, item) => res += this.$IsNum(item.trucking_fee), 0)
        },
        SERVICE(){
            return this.CREDIT_PAYMENTS.reduce((res, item) => res += this.$IsNum(item.service_charge), 0)
        },
        PAID(){
            return this.CREDIT_PAYMENTS.reduce((res, item) => res += this.$IsNum(item.paid_amount), 0)
        }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      getCharge(customer, type){
        console.log(customer, type)
        var charge= this.charges.reduce((res,item)=>{
          console.log(customer, item.customer)
            if(customer== item.customer) {
              if(type == 'service_charge') {
                res = item.service_charge
              } else if(type == 'trucking_fee'){
                res = item.trucking_fee
              }
             
            }
            return res
        },0)
        return charge
      },
      getUsers: function() { 
        this.$http.post("user/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.users = response.data.data:this.users =[]
        }).catch(e => {
        console.log(e.data)
        })
     },
         getItems: function() {
           this.summaries = []
              this.$http.post("transaction/query_cashier_payments", {start_date: this.selected_date}).then(response => {
                    response.data.items != null?this.summaries = response.data.items: this.summaries = []
                    response.data.charges != null?this.charges = response.data.charges: this.charges = []
                   // this.FormatData()
            }).catch(e => {
             console.log(e.data)
           })
        }
    }
  }
  </script>
  